import { gql } from '@apollo/client';

export const GET_TOP_POWER_SUPPLIES = gql`
  query GetTopPowerSupplies($filters: DistributionGraphsInput) {
    getTopPowerSupplies(input: $filters) {
      amountOfListings
      label
    }
  }
`;
